export abstract class HeatmapTypeStrings {
  static types = ['Estações', 'Heatmap', 'Vias', 'Rios'];
}